"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRCodeCard = void 0;
var _litHtml = require("lit-html");
var _solidUi = require("solid-ui");
require("./styles/QRCodeCard.css");
var _texts = require("./texts");
/* Part of this code was generated by AI Model: GPT-5.3-Codex */
/* Prompt: The QRCode has a label "link to profile" but it should
 be a VCARD with name, and link to profile. So when you scan it 
 it goes into your contacts. That's the current way works, IIRC. */

function isNamedNodeLike(value) {
  return Boolean(value && typeof value === 'object' && typeof value.uri === 'string');
}
function isStoreLike(value) {
  return Boolean(value && typeof value === 'object' && typeof value.any === 'function');
}
function resolveQRCodeArgs(arg1, arg2, arg3) {
  if (isNamedNodeLike(arg1)) {
    return {
      subject: arg1,
      store: isStoreLike(arg2) ? arg2 : undefined
    };
  }
  if (isNamedNodeLike(arg3)) {
    return {
      subject: arg3,
      store: isStoreLike(arg2) ? arg2 : undefined
    };
  }
  throw new Error('QRCodeCard requires a profile subject NamedNode.');
}
function normalizeEmail(value) {
  return (value || '').trim().replace(/^mailto:/i, '');
}
function normalizeTelephone(value) {
  return (value || '').trim().replace(/^tel:/i, '');
}
function isEmailValue(value) {
  const normalized = (value || '').trim();
  if (!normalized) return false;
  if (/^mailto:/i.test(normalized)) return true;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized);
}
function isPhoneValue(value) {
  const normalized = (value || '').trim();
  if (!normalized) return false;
  if (/^tel:/i.test(normalized)) return true;
  return /^[+()\-\s\d]{5,}$/.test(normalized);
}
function firstContactValue(store, subject, predicate, kind) {
  if (!store) return '';
  const candidates = store.each(subject, predicate);
  const isExpectedValue = kind === 'email' ? isEmailValue : isPhoneValue;
  for (const node of candidates) {
    if (!node) continue;
    const direct = node.value;
    if (typeof direct === 'string' && isExpectedValue(direct)) {
      return kind === 'email' ? normalizeEmail(direct) : normalizeTelephone(direct);
    }
    if (node.termType === 'NamedNode' || node.termType === 'BlankNode') {
      const doc = subject.doc();
      const inDocStatements = store.statementsMatching(node, _solidUi.ns.vcard('value'), null, doc);
      const anyGraphStatements = store.statementsMatching(node, _solidUi.ns.vcard('value'));
      for (const statement of [...inDocStatements, ...anyGraphStatements]) {
        const viaValue = statement.object?.value;
        if (typeof viaValue === 'string' && isExpectedValue(viaValue)) {
          return kind === 'email' ? normalizeEmail(viaValue) : normalizeTelephone(viaValue);
        }
      }
    }
  }
  return '';
}
const QRCodeCard = (arg1, arg2, arg3) => {
  const {
    subject,
    store
  } = resolveQRCodeArgs(arg1, arg2, arg3);
  const name = _solidUi.utils.label(subject);
  const escapeVCardValue = value => {
    return (value || '').replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n');
  };
  const safeName = escapeVCardValue(name || subject.uri);
  const safeUrl = escapeVCardValue(subject.uri);
  const email = firstContactValue(store, subject, _solidUi.ns.vcard('hasEmail'), 'email');
  const telephone = firstContactValue(store, subject, _solidUi.ns.vcard('hasTelephone'), 'tel');
  const vCardLines = ['BEGIN:VCARD', 'VERSION:4.0', `FN:${safeName}`, `URL:${safeUrl}`];
  if (email) {
    vCardLines.push(`EMAIL;TYPE=internet:${escapeVCardValue(email)}`);
  }
  if (telephone) {
    vCardLines.push(`TEL:${escapeVCardValue(telephone)}`);
  }
  vCardLines.push('END:VCARD');
  const vCard = vCardLines.join('\r\n');

  // console.log(`@@ qrcodes colours highlightColor ${highlightColor}, backgroundColor ${backgroundColor}`)

  return (0, _litHtml.html)`
    <figure 
      class="qrcode-card flex-column-center"
      data-value="${vCard}"
      data-testid="qrcode-card"
      aria-labelledby="qr-code-caption"
      role="img"
      aria-describedby="qr-code-description"
    >
      <div 
        aria-label="Static QR code containing contact information for ${name}"
        role="img"
        tabindex="0"
      ></div>
      <figcaption 
        id="qr-code-caption" 
        class="qrcode-card__caption"
      >
        ${_texts.scanQrToConnectText}
      </figcaption>
      <div 
        id="qr-code-description" 
        class="sr-only"
      >
        This is a static QR code containing vCard information for ${name}, including profile URL ${subject.uri}. The QR code is not interactive.
      </div>
    </figure>
  `;
};
exports.QRCodeCard = QRCodeCard;